import { LocalRepState } from '../enums';

export const relevantRepresentatives = (localRepState, repData) => {
    if (!repData || !repData.length || localRepState === LocalRepState.disabled) {
        return [];
    }

    if (localRepState === LocalRepState.houseRep) {
        return [repData[0]];
    }
    if (localRepState === LocalRepState.senators) {
        return repData.slice(1).reverse();
    }
    return repData.slice(0).reverse();
};

export const joinEnglish = arr => {
    if (!arr || !arr.length) {
        return '';
    }
    if (arr.length === 1) {
        return arr[0];
    }
    return arr.slice(0, arr.length - 1).join(', ') + ' and ' + arr[arr.length - 1];
};



// WEBPACK FOOTER //
// ./src/utils/localRepresentative/parser.js